/**
 * AI Translator default settings and utilities
 */

import i18n from "@/languageConfig"

export type CustomTranslation = { original: string; translation: string }

export type AITranslatorSettings = {
  availableLanguages: string[]
  selectedLanguage: string
  selectedLanguages?: string[]
  translationInstructions: string
  customTranslations: CustomTranslation[]
}

// Every language in `supportedLngs` (languageConfig.ts) needs an entry, or a
// user on that UI language silently gets English output (#2968).
const codeToDisplayLanguage: Record<string, string> = {
  en: "English",
  sv: "Svenska",
  no: "Norsk",
  fi: "Suomi",
  de: "Deutsch",
}

export function getSiteDisplayLanguage(): string {
  const code = (i18n.resolvedLanguage || i18n.language || "en").split("-")[0]
  return codeToDisplayLanguage[code] ?? "English"
}

export const defaultSettings: AITranslatorSettings = {
  availableLanguages: ["Svenska", "English", "Norsk", "Suomi", "Deutsch"],
  selectedLanguage: getSiteDisplayLanguage(),
  translationInstructions: "",
  customTranslations: [],
}
